import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function Footer() {
  return (
    <footer className="mt-auto bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                91韩漫画
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              按校园、奇幻、都市、恋爱、悬疑等题材精细分类，热门剧情韩漫一网打尽。想看特定类型的韩漫，直接进分类就能找到。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">题材分类</h4>
            <ul className="mt-4 space-y-2">
              {genres.map((g) => (
                <li key={g.id}>
                  <Link
                    to={`/category/${g.id}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {g.name}漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">快捷导航</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-600">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-600">
              <li>
                <a href="mailto:service@91hanmanhua.com" className="hover:text-primary-600">
                  service@91hanmanhua.com
                </a>
              </li>
              <li>投稿合作：editor@91hanmanhua.com</li>
              <li className="pt-2 text-xs text-foreground-500">
                仅提供漫画资讯与内容导航服务
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-background-200">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 91韩漫画 · 专注韩漫题材分类与内容推荐
          </p>
          <div className="flex items-center gap-4">
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-600">
              回到顶部
            </a>
            <span className="text-xs text-foreground-500">本站内容仅供学习交流</span>
          </div>
        </div>
      </div>
    </footer>
  );
}